
































































































import 'bootstrap';
import bootbox from 'bootbox';
import datefns from 'date-fns';
import { Component, Vue } from 'vue-property-decorator';
import JobCorpsCenter from '@/classes/JobCorpsCenter';
import Certification from '@/classes/Certification';
import binaryDownload from '@/services/BinaryDownloader';

interface TrackingReportRequest {
    certificationNames?: string[];
    completionDateStart: string;
    completionDateEnd: string;
    jobCorpsCenterIds?: number[];
    summarizedBy: string;
    spreadsheet: boolean;
}

@Component
export default class StudentCertificationTracking extends Vue {

    private searchCertificationNames: string[] = [];
    private searchCompletionDateStart: string = '';
    private searchCompletionDateEnd: string = '';
    private searchJobCorpsCenterIds: number[] = [];
    private summarizedBy: string = 'CERTIFICATE';

    public mounted() {
        this.$store.dispatch('loadCertificates', true);
        this.$store.dispatch('loadCenters');
    }

    get jobCorpsCenters(): JobCorpsCenter[] {
        const centers: JobCorpsCenter[] | undefined = this.$store.getters.getJobCorpsCentersAllowed;
        if (centers !== undefined) {
            return centers;
        } else {
            return [];
        }
    }

    get certifications(): Certification[] {
        const certs: Certification[] | undefined = this.$store.getters.getCertifications;
        if (certs !== undefined) {
            return certs;
        } else {
            return [];
        }
    }

    get validDates(): boolean {

        const dRegex = /\d{4}-\d{2}-\d{2}/;

        if (!dRegex.test(this.searchCompletionDateStart) || !dRegex.test(this.searchCompletionDateEnd)) {
            return false;
        }

        const start = new Date(this.searchCompletionDateStart);
        start.setHours(0, 0, 0, 0);
        const end = new Date(this.searchCompletionDateEnd);
        end.setHours(23, 59, 59, 999);

        const diff = Math.abs(Math.abs(datefns.differenceInYears(start, end)));

        // Restrict the range to less than one year.
        return !isNaN(diff) && 1 > diff;
    }

    private generateReport(asSpreadsheet: boolean): void {

        try {

            const criteria = this.getCriteria(asSpreadsheet);

            binaryDownload('POST', '/api/v1/report/studentcerttracking', JSON.stringify(criteria))
                .catch((err) => {
                    bootbox.alert(err);
                });

        } catch (error) {
            bootbox.alert(error.message);
        }
    }

    private clearCriteria(): void {
        this.searchCertificationNames = [];
        this.searchCompletionDateStart = '';
        this.searchCompletionDateEnd = '';
        this.searchJobCorpsCenterIds = [];

        this.summarizedBy = 'CERTIFICATE';
    }

    private getCriteria(asSpreadhseet: boolean): TrackingReportRequest {

        if (!this.validDates) {
            throw new Error('Please enter the date range before running this report.');
        }

        return {
            certificationNames: this.searchCertificationNames,
            completionDateStart: this.searchCompletionDateStart,
            completionDateEnd: this.searchCompletionDateEnd,
            jobCorpsCenterIds: this.searchJobCorpsCenterIds,
            summarizedBy: this.summarizedBy,
            spreadsheet: asSpreadhseet
        };
    }
}
